export default (opts = {}) => ({
    swiper: null,
    initialized: false,
    analytics: {
        label: opts.label || null,
        currency: opts.currency || null,
        listId: opts.listId || 'category_tabs',
    },
    init() {
        this.enable();
    },
    enable() {
        this.swiper = new Swiper(this.$refs.productsTabCarousel, {
            slidesPerView: 4,
            spaceBetween: 8,
            pagination: false,
            loop: true,
            navigation: {
                nextEl: this.$refs.next,
                prevEl: this.$refs.previous
            },
            breakpoints: {
                320: {
                    slidesPerView: 1.5,
                },
                568: {
                    slidesPerView: 2.5,
                },
                1024: {
                    slidesPerView: 3,
                },
                1536: {
                    slidesPerView: 4,
                    spaceBetween: 12,
                }
            },
            autoplay: {
                delay: 333000,
                disableOnInteraction: false
            },
            keyboard: {
                enabled: true
            },
            on: {
                init: () => {
                    requestAnimationFrame(() => {
                        this.initialized = true;
                    });
                },
            },
        });
    },
    onItemClick(event) {
        const link = event.target.closest('.swiper-slide a');
        if (!link) return;
        const slide = event.target.closest('.swiper-slide');
        if (!slide) return;

        const item = {
            item_id: slide.dataset.itemId,
            item_name: slide.dataset.itemName,
        };

        const payload = {
            event: 'view_item_list',
            currency: this.analytics.currency,
            item_list_id: this.analytics.listId,
            item_list_name: this.analytics.label,
            items: [item],
        };

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(payload);
    }
})
